import Vue from 'vue'
import Vuelidate from 'vuelidate'
import LrApp from './LrApp.vue'
import Loader from '@/components/Loader'
import './registerServiceWorker'
import router from './router'
import store from './store'
import titlesPlugin from '@/utils/titles.plugin'
import messagePlugin from '@/utils/message.plugin'
import VueYandexMetrika from 'vue-yandex-metrika'  

import dateFilter from '@/filters/date.filter'

import 'materialize-css/dist/js/materialize.min'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(titlesPlugin)
Vue.use(messagePlugin)
Vue.use(VueYandexMetrika, {
  id: 65956333,
  router: router,
  env: process.env.NODE_ENV
})

Vue.filter('date', dateFilter)
Vue.component('Loader', Loader)


new Vue({
  router: router,
  store: store,
  render: h => h(LrApp)
}).$mount('#lrApp')

